export default __webpack_public_path__ + "d6db7ec810dfc37edb47fc2fefe28d4c.svg";